var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1168"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icon / Close",
    rx: 0,
    width: 23,
    height: 23,
    transform: "translate(0.500000 0.500000)",
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Icon / Close",
    rx: 0,
    width: 23,
    height: 23,
    transform: "translate(0.500000 0.500000)",
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M5.82324 5.82324C6.12024 5.52612 6.58691 5.52612 6.88391 5.823L12.0021 10.9399L17.1202 5.823C17.4172 5.52612 17.884 5.52612 18.1809 5.82324C18.4779 6.12012 18.4778 6.58691 18.1808 6.88379L13.0629 12.0005L18.1804 17.1167C18.4774 17.4138 18.4775 17.8804 18.1805 18.1775C17.8837 18.4744 17.4169 18.4746 17.1199 18.1775L12.0021 13.061L6.88428 18.1775C6.58728 18.4746 6.12061 18.4744 5.82361 18.1775C5.52673 17.8804 5.52673 17.4138 5.82373 17.1167L10.9413 12.0005L5.82336 6.88379C5.52637 6.58691 5.52637 6.12012 5.82324 5.82324Z",
    clipRule: "evenodd",
    fill: "#8F849A",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.bb00d3c4a3e3ddf2b714b8742cfb7d7e.svg";
export { ForwardRef as ReactComponent };